import { Auth as FirebaseAuth } from '@/integrations/firebase/config';

/**
 * Get the current Firebase ID token for authenticated API calls
 * @returns Promise<string> The Firebase ID token
 * @throws Error if user is not authenticated
 */
export async function getFirebaseToken(): Promise<string> {
  const user = FirebaseAuth.currentUser;
  if (!user) {
    throw new Error('User not authenticated');
  }
  
  try {
    const token = await user.getIdToken(false);
    return token;
  } catch (error) {
    console.error('Failed to get Firebase token:', error);
    throw new Error('Failed to get authentication token');
  }
}

/**
 * Get the current Firebase user's UID
 * @returns string | null The user's UID or null if not authenticated
 */
export function getCurrentUserUid(): string | null {
  return FirebaseAuth.currentUser?.uid || null;
}

/**
 * Check if user is currently authenticated
 * @returns boolean True if user is authenticated
 */
export function isAuthenticated(): boolean {
  return !!FirebaseAuth.currentUser;
}